<template>
  <div class="home">
    <header>
      <form v-if="isShow" action="jaegerexcute" style="height: 100%; color: white; font-size: 20pt;">
     <table style="height:100%; width:100%;" border="0">
       <tr style="height:30%;">
         <td align="center" valign="middle">
           <img src="../assets/img/jaeger.png" style="width: 40%;">						
         </td>
       </tr>
       <tr style="height:40%;">
         <td align="center" valign="middle">
           Digital Caliber Showcase Status Report<br><br>
           <div style="color: red;" :class="index === 0 ? 'hidden' : 'show'">Date Not Selected</div><br>
           Username: <input name="userName" type="text" v-model="userName" style="width: 50%; height: 50px; font-size: 20pt"/><br><br>
           Password: <input name="passWord" type="password" v-model="passWord" style="width: 50%;height: 50px;font-size: 20pt; margin-left: 5px;"/><br><br><br><br>
           <input type="reset" name="submit" @click="Login()" value="Login" style=" width: 20%;height: 56px;font-size: 20pt;cursor: pointer;text-align: center;"/>
         </td>
       </tr>
       <tr style="height:30%;">
         <td align="center" valign="middle">
           <img src="../assets/img/wonderlabs.png" style="width: 20%;">				
         </td>
       </tr>
     </table>
   </form>
     <form v-if="!isShow" action="jaegerexcute" method="get" style="height: 100%; color: white; font-size: 20pt;">
     <table style="height:100%; width:100%;" border="0">
       <tr style="height:30%;">
         <td align="center" valign="middle">
           <img src="../assets/img/jaeger.png" style="width: 40%;">						
         </td>
       </tr>
       <tr style="height:40%;">
         <td align="center" valign="middle">
           Digital Caliber Showcase Status Report<br><br>
           <div style="color: red;" :class="index === 0 ? 'hidden' : 'show'">Date Not Selected</div><br>
           Start Date: <input name="begDate" type="date"  v-model="beginTime" style="width: 50%; height: 50px; font-size: 20pt;"/><br><br>
           End Date: <input name="endDate" type="date" v-model="endTime" style="width: 50%; height: 50px; font-size: 20pt;margin-left:5px;"/><br><br><br><br>
           <input type="reset" name="submit" @click="time()" value="Generate Report" style="width: 20%; height: 56px; font-size: 20pt;cursor: pointer;text-align:center;"/>
         </td>
       </tr>
       <tr style="height:30%;">
         <td align="center" valign="middle">
           <img src="../assets/img/wonderlabs.png" style="width: 20%;">				
         </td>
       </tr>
     </table>
   </form>
   </header>
  </div>
</template>

<script>
import "axios";
import axios from 'axios'
import XLSX from 'xlsx'
import dateSheet from '@/date/date.js'
import timeDateSheet from '@/date/timeDate.js'
export default {
 name: "home",
 data() {
   return {
     timeList: [],
     beginTime: '',
     endTime:'',
     index: 0,
     // 过滤月份
     dataMonth: [],
     dataYear: [],
     stayTimeAll: 0,

    isShow:true,
    userName: '',
    passWord: '',
   }
 },
 methods: {
    Login() {
      axios.post("https://h5.mixwechat.com/jaeger_video_viewer/login",{
        username:this.userName,
        password:this.passWord
      }).then((res) => {
         if (res.data.ok === 1) {
          this.isShow = false
         } else if ( this.userName === '' || this.passWord === '' ) {
          alert('The account password cannot be empty')
         } else {
          alert('The account or password does not match')
         }
      })
      
    },
    downLoadFile(item,data) {
      const link = document.createElement('a')
      
      link.target = '_blank'
      link.style.display = 'none'
      link.download = item
      link.href = data
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
   time () {
    //  if (this.beginTime === '' || this.endTime === ''){
    //    this.index = 1
    //    return
    //  }else {
    //    this.index = 0
    //  }
    //  var beginTimeStr = new Date(this.beginTime).toISOString().split('T')[0].replace(/\//g,"-")
    //  var endTimeStr = new Date(this.endTime).toISOString().split('T')[0].replace(/\//g,"-")
     var data = new Date()
     var year = new Date().getFullYear()
     var monthDay = data.getMonth() + 1 < 10 ? '0' +( data.getMonth() + 1) : data.getMonth() + 1
     var day = data.getDate() < 10 ? '0' + (data.getDate()) : data.getDate()

     if (this.beginTime === "" || this.endTime === "") {
        this.downLoadFile("JLC Digital Showcase Report_" + year + '-' + monthDay + '-' + day + ".xlsx", 'https://h5.mixwechat.com/jaeger/exportRecord?all=1')
        return
      } else {
        this.downLoadFile("JLC Digital Showcase Report_" +
            this.beginTime +
            "_" +
            this.endTime +
            ".xlsx", 'https://h5.mixwechat.com/jaeger/exportRecord?s='+this.beginTime+'&e='+this.endTime)
            return
      }


    //  var params = {
    //    nx_formid: "61de44d995c9854947e0f47e",
    //  };
    //  if (beginTimeStr < '2023-12-01') {
    //    params.starttime = {
    //      $gt: beginTimeStr + " 00:00:00",
    //      $lt: year + '-' + monthDay + '-' + day + " 23:59:59",
    //    }
    //   } else {
    //    params.starttime = {
    //      $gt: "2023-12-01 00:00:00",
    //      $lt: year + '-' + monthDay + '-' + day + " 23:59:59",
    //    }
    //   }
    //  axios.post('https://form.mixwechat.com/api/interface/info/onedata',params).then(res => {
    //   const wb = XLSX.utils.book_new()
    //   const wsName = 'Sheet1'
    //   this.dataYear = res.data.data.filter(a => a.sid < 100)
    //   var filterTime = res.data.data.filter((p) => p.starttime >= beginTimeStr + " 00:00:00" && p.endtime <= endTimeStr + " 23:59:59")
    //   this.timeList = filterTime.filter(a => a.sid < 100)

    //   // Sheet1
    //   this.date(beginTimeStr,endTimeStr,res,this.timeList,dateSheet,wb,wsName)
    //   var beginTime = beginTimeStr.replace(/[-/]/g,"")
    //   var endTime = endTimeStr.replace(/[-/]/g,"")
    //   console.log('time', beginTime, endTime)
    //   const filename = 'JLC Digital Showcase Report_' + beginTime + '_' + endTime + '.xlsx'
      
    //   // 月
    //   const wsMonthName = new Date(this.beginTime).toLocaleString("en-US", { month: "long" })
    //   this.timeDate(this.timeList,timeDateSheet,wb,wsMonthName)

    //   // 年
    //   const wsYearName = 'YEAR'
    //   this.timeDate(this.dataYear,timeDateSheet,wb,wsYearName)
    
    //    /* write workbook */
    //    XLSX.writeFile(wb, filename)
    //  })
     
   },
   date(beginTimeStr,endTimeStr,res,AllDate,columnArr,wb,name) {
    var filterTime = res.data.data.filter((p) => p.starttime >= beginTimeStr + " 00:00:00" && p.endtime <= endTimeStr + " 23:59:59")
    AllDate = filterTime.filter(a => a.sid < 100)
    AllDate.forEach((a) => {
      if (a.sid * 1 === 0) {
        a.sid = 'Shanghai K11'
      }else if (a.sid * 1 === 1) {
        a.sid = 'HK PP'
      } else if (a.sid * 1 === 3) {
        a.sid = 'Popup Event'
      } else if (a.sid * 1 === 4) {
        a.sid = 'HongKong PP'
      } else if (a.sid * 1 === 5) {
        a.sid = 'NewYork'
      } else if (a.sid * 1 === 6) {
        a.sid = 'Thailand'
      } else if (a.sid * 1 === 7) {
        a.sid = 'IB Munich'
      } else if (a.sid * 1 === 8) {
        a.sid = 'Singapore Marine Bay'
      } else if (a.sid * 1 === 9) {
        a.sid = 'Shengyang MixCity'
      }
      AllDate.forEach((b) => {
        if (b.lang * 1 === 0) {
          b.lang = 'Chinese'
        } else if (b.lang * 1 === 1) {
          b.lang = 'English'
        } else if (b.lang * 1 === 2) {
          b.lang = 'Chinese traditional'
        } else if (b.lang * 1 === 3) {
          b.lang = 'French'
        } else if (b.lang * 1 === 4) {
          b.lang = 'German'
        } else if (b.lang * 1 === 5) {
          b.lang = 'Korean'
        }
      })
      // console.log(a.sid,a.lang)
    })
    
    const theKeys = columnArr.map(k => k.keywords)
    const headers = columnArr.map(k => k.name)
    const aoaData = [headers]
    this.timeList.forEach(d => {
      const saveArray = []
      theKeys.forEach(key => {
        if (d[key] === undefined) {
        d[key] = ''
        }
        saveArray.push(d[key])
      })
      aoaData.push(saveArray)
    })

    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(aoaData), name)
   
   },
   timeDate(AllDate,columnArr,wb,name) {
    AllDate.forEach((a) => {
        if (a.sid * 1 === 0) {
          a.sid = 'Shanghai K11'
        }else if (a.sid * 1 === 1) {
          a.sid = 'HK PP'
        } else if (a.sid * 1 === 3) {
          a.sid = 'Popup Event'
        } else if (a.sid * 1 === 4) {
          a.sid = 'HongKong PP'
        } else if (a.sid * 1 === 5) {
          a.sid = 'NewYork'
        } else if (a.sid * 1 === 6) {
          a.sid = 'Thailand'
        } else if (a.sid * 1 === 7) {
          a.sid = 'IB Munich'
        } else if (a.sid * 1 === 8) {
          a.sid = 'Singapore Marine Bay'
        } else if (a.sid * 1 === 9) {
          a.sid = 'Shengyang MixCity'
        }
       AllDate.forEach((b) => {
          if (b.lang * 1 === 0) {
            b.lang = 'Chinese'
          } else if (b.lang * 1 === 1) {
            b.lang = 'English'
          } else if (b.lang * 1 === 2) {
            b.lang = 'Chinese traditional'
          } else if (b.lang * 1 === 3) {
            b.lang = 'French'
          } else if (b.lang * 1 === 4) {
            b.lang = 'German'
          } else if (b.lang * 1 === 5) {
            b.lang = 'Korean'
          }
        })
    })
    const number = []
    const newNumber = []
    AllDate.forEach((p) => {
      const sidNumber = p.sid
      if (number[sidNumber]) {
        number[sidNumber]++;
      } else {
        number[sidNumber] = 1
      }
    })
				
      for (let i = 0; i < Object.keys(number).length; i++) {
        // 每次重新计算每个店铺所有的播放时间
        this.stayTimeAllMonth = 0
        
        let objList = {
          sid: '', 
          Number: 0,
          staytime: 0,
          calibre1: 0,
          calibre1ov: 0,
          calibre1fn: 0,
          calibre1rw: 0,
          calibre1gm: 0,
          calibre1st: 0,
          calibre2: 0,
          calibre2ov: 0,
          calibre2fn: 0,
          calibre2rw: 0,
          calibre2gm: 0,
          calibre2st: 0,
          calibre5: 0,
          calibre5ov: 0,
          calibre5fn: 0,
          calibre5rw: 0,
          calibre5gm: 0,
          calibre5st: 0,
          calibre4: 0,
          calibre4ov: 0,
          calibre4fn: 0,
          calibre4rw: 0,
          calibre4gm: 0,
          calibre4st: 0,
          calibre3: 0,
          calibre3ov: 0,
          calibre3fn: 0,
          calibre3rw: 0,
          calibre3gm: 0,
          calibre3st: 0,
        }
        
        AllDate.filter(p => p.sid === Object.keys(number)[i]).forEach(item => {
          this.stayTimeAllMonth += item.staytime * 1 
          // Shop ID
          objList.sid = Object.keys(number)[i]
          // Number of User
          objList.Number = Object.values(number)[i]
          // Avg Stay (sec)
          objList.staytime = Math.round( this.stayTimeAllMonth * 1 / objList.Number * 1 )
          
          objList.calibre1 += item.calibre1
          objList.calibre1ov += item.calibre1ov
          objList.calibre1fn += item.calibre1fn
          objList.calibre1rw += item.calibre1rw
          objList.calibre1gm += item.calibre1gm
          objList.calibre1st += item.calibre1st
          objList.calibre2 += item.calibre2
          objList.calibre2ov += item.calibre2ov
          objList.calibre2fn += item.calibre2fn
          objList.calibre2rw += item.calibre2rw
          objList.calibre2gm += item.calibre2gm
          objList.calibre2st += item.calibre2st
          objList.calibre5 += item.calibre5
          objList.calibre5ov += item.calibre5ov
          objList.calibre5fn += item.calibre5fn
          objList.calibre5rw += item.calibre5rw
          objList.calibre5gm += item.calibre5gm
          objList.calibre5st += item.calibre5st
          objList.calibre4 += item.calibre4
          objList.calibre4ov += item.calibre4ov
          objList.calibre4fn += item.calibre4fn
          objList.calibre4rw += item.calibre4rw
          objList.calibre4gm += item.calibre4gm
          objList.calibre4st += item.calibre4st
          objList.calibre3 += item.calibre3
          objList.calibre3ov += item.calibre3ov
          objList.calibre3fn += item.calibre3fn
          objList.calibre3rw += item.calibre3rw
          objList.calibre3gm += item.calibre3gm
          objList.calibre3st += item.calibre3st
        
        })
        newNumber.push(objList)
      }
    
      const theKeysMonth = columnArr.map(k => k.keywords)
      const headersMonth = columnArr.map(k => k.name)
      const aoaDataMonth = [headersMonth]
      newNumber.forEach(d => {
        const saveArray = []
        theKeysMonth.forEach(key => {
          if (d[key] === undefined) {
          d[key] = ''
          }
          saveArray.push(d[key])
        })
        aoaDataMonth.push(saveArray)
      })

      XLSX.utils.book_append_sheet(wb,XLSX.utils.aoa_to_sheet(aoaDataMonth), name)
   }
 }
};
</script>
<style scoped>
.home{
   height: 100%;
}
header{
   padding: 0;
 margin: 0;
 background-color: black;
 overflow: auto;
   height: 100%;
}
input{
   padding: 0 10px;

}
.show{
 display: block;
}
.hidden{
 display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/ce.vue